import { lazy } from 'react';

export const ConnectWallet = lazy(() => import('./ConnectWallet.component'));
